import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './currentGraph.css';

const CurrentGraph = ({ data }) => {
  const formattedData = data.map((value, index) => ({
    time: index,
    value: value,
  }));

  const maxTime = formattedData.length;

  let majorTickInterval;

  if (maxTime < 15) {
    majorTickInterval = 1;
  } else if (maxTime < 30) {
    majorTickInterval = 5;
  } else if (maxTime < 45) {
    majorTickInterval = 10;
  } else if (maxTime < 60) {
    majorTickInterval = 15;
  } else if (maxTime < 180) {
    majorTickInterval = 30;
  } else if (maxTime < 300) {
    majorTickInterval = 60;
  } else if (maxTime < 600) {
    majorTickInterval = 150;
  } else if (maxTime < 900) {
    majorTickInterval = 300;
  } else if (maxTime < 1800) {
    majorTickInterval = 600;
  } else {
    majorTickInterval = 900;
  }

  const majorTicks = Array.from({ length: Math.ceil(maxTime / majorTickInterval) }, (_, i) => i * majorTickInterval);

  const formatXAxisTick = (tick) => {
    const totalSeconds = tick;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (minutes > 0 && seconds === 0) {
      return `${minutes}m`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
  };

  // Tooltip label formatter to add "Time" before the X-axis value
  const labelFormatter = (label) => {
    return `Time: ${label}s`;
  };

  return (
    <ResponsiveContainer width="100%" height={200}>
      <AreaChart data={formattedData} className="custom-area-chart">
        <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
        <XAxis 
          dataKey="time" 
          ticks={majorTicks} 
          tickFormatter={formatXAxisTick} 
          tick={{ fill: '#666' }} 
          axisLine={{ stroke: '#888' }} 
          tickLine={{ stroke: '#888' }} 
        />
        <YAxis 
          domain={[0, 10]} 
          ticks={[0, 2, 4, 6, 8, 10]} 
          tick={{ fill: '#666' }} 
          axisLine={{ stroke: '#888' }} 
          tickLine={{ stroke: '#888' }} 
        />
        <Tooltip 
          contentStyle={{ width: '200px' }}  /* Set fixed width for the tooltip box */
          wrapperStyle={{ width: '200px' }}  /* Control the wrapper's width */
          labelFormatter={labelFormatter}  /* Format X-axis label to show "Time" */
          formatter={(value) => [`${value.toFixed(1)}`, 'Response']}  /* Rename "value" to "Response" */
          itemStyle={{ color: '#333' }}  /* Set text color inside tooltip */
        />
        <Area 
          type="monotone" 
          dataKey="value" 
          stroke="#2196f3"
          fill="#2196f3"
          strokeWidth={4}
          dot={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default CurrentGraph;
